<template>
	<div class="box">
		<el-container style="height:100%;overflow: hidden;">
			<el-header>
				<AppMain />
			</el-header>
			<div style="min-height: 100%;height:auto;display:flex">
				<el-aside class="menuList">
					<AsideNav @switchAsideNavHd="switchAsideNavHd()" />
				</el-aside>
				<el-card class="box-card" style="width: 100%;height: 96%;margin: 10px;">
					<el-main>
						<router-view />
					</el-main>
				</el-card>
			</div>
		</el-container>
	</div>
</template>
<script>
	import AsideNav from '../AsideNav/index.vue';
	import AppMain from '../AppMain/index.vue';
	export default {
		name: 'Layout',
		data() {
			return {
				asideNavHd: false
			}
		},
		components: {
			AsideNav,
			AppMain
		},
		methods: {
			switchAsideNavHd() {
				this.asideNavHd = !this.asideNavHd;
				console.log(this.asideNavHd);
			}
		}
	};
</script>
<style lang="less" scoped>
	.box {
		height: 100%;
		position: relative;
	}

	.block {
		position: absolute;
		bottom: 0;
		left: 50%;
	}

	.menuList {
		width: auto !important;
		height: 95%;
		-moz-box-shadow: -8px 7px 13px 6px #c6c6c6;
		-webkit-box-shadow: -8px 7px 13px 6px #c6c6c6;
		box-shadow: -8px 7px 13px 6px #c6c6c6;
	}

	/deep/.el-header {
		padding: 0;
		height: auto;
		-moz-box-shadow: 0px -10px 20px 0px #c6c6c6;
		-webkit-box-shadow: 0px -10px 20px 0px #c6c6c6;
		box-shadow: 0px -10px 20px 0px #c6c6c6;
		z-index: 1;
	}
</style>
